module.exports = __webpack_public_path__ + "static/team-jro.04ffd72d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team-jro.png
// module id = 975
// module chunks = 263791100135453